import React from 'react';
import onClickOutside from 'react-onclickoutside';
import classnames from 'classnames';

import './style.scss';

interface ICreateOption {
  onClick: (e: React.SyntheticEvent<HTMLElement>) => void;
  URL?: string;
  label?: string;
}

interface ICreateOptionsDropdownProps {
  show: boolean;
  onClose: (e: React.SyntheticEvent<any>) => void;
  pathName: string;
  options: ICreateOption[];
  promo?: React.ReactNode;
}

interface ICreateOptionsdownState {}

const optionIconSrc = (label?: string) =>
  label === 'Customer Submission' ? '/assets/create-submission.svg' : '/assets/create-case.svg';

export class CreateOptionsDropdown extends React.Component<ICreateOptionsDropdownProps, ICreateOptionsdownState> {
  isActiveTool = (url: string) => this.props.pathName.includes(url);

  handleClickOutside = (e: any) => {
    const menuIconClassName = 'app-header__new';
    const targetClassNames = Array.from(e.target.classList);
    const isTargetMenuIcon = targetClassNames.indexOf(menuIconClassName) !== -1;

    if (!isTargetMenuIcon) {
      this.props.onClose(e);
    }
  };

  renderCreateOptions = (option: ICreateOption, index): JSX.Element => {
    const onToolClick = (e: React.SyntheticEvent<HTMLElement>) => {
      if (option.onClick) {
        option.onClick(e);
        this.props.onClose(e);
      }
    };

    return (
      <div
        key={index}
        className={classnames('create-options__option', 'create-options__option--card', 'flex-column--left', {
          active: this.isActiveTool(option.URL),
        })}
        onClick={onToolClick}
      >
        <a className="create-options__option-card" href={option.URL}>
          <span className="create-options__option-icon">
            <img src={optionIconSrc(option.label)} alt="" width={18} height={18} />
          </span>
          <span className="create-options-dropdown__option-name">{option.label}</span>
          <span className="create-options__option-chevron" aria-hidden="true">
            ›
          </span>
        </a>
      </div>
    );
  };

  render() {
    return (
      <div
        className={classnames('create-options-dropdown', 'grid-2-row', {
          'create-options-dropdown--visible': this.props.show,
          'create-options-dropdown--with-promo': Boolean(this.props.promo),
        })}
      >
        <p className="create-options-dropdown__eyebrow">Create</p>
        {this.props.options.map((option, index) => this.renderCreateOptions(option, index))}
        {this.props.promo}
      </div>
    );
  }
}

export default onClickOutside(CreateOptionsDropdown);
